
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.025 52.454c-12.408 0-22.496-10.046-22.496-22.4 0-12.356 10.088-22.401 22.496-22.401s22.497 10.045 22.497 22.4c0 12.355-10.089 22.4-22.497 22.4zm0-42.81c-11.298 0-20.496 9.16-20.496 20.41s9.198 20.409 20.496 20.409c11.299 0 20.497-9.16 20.497-20.41S41.334 9.644 30.025 9.644z"}}),_c('path',{attrs:{"d":"M30.025 23.642c1.105 0 2-.892 2-1.991 0-1.1-.895-1.992-2-1.992-1.104 0-2 .892-2 1.992s.896 1.99 2 1.99zM30.025 41.433a1 1 0 01-1-.996v-13.65a1 1 0 012 0v13.65c0 .558-.44.996-1 .996z"}})])
          )
        }
      }
    